<template>
  <div>
    <basic-customer-inquiry-reg v-if="!isLaunchpack"></basic-customer-inquiry-reg>
    <launchpack-customer-inquiry-reg v-if="isLaunchpack"></launchpack-customer-inquiry-reg>
  </div>
</template>

<script>

  import BasicCustomerInquiryReg from "./BasicCustomerInquiryReg";
  import LaunchpackCustomerInquiryReg from "./LaunchpackCustomerInquiryReg";

  export default {
    components: {
      LaunchpackCustomerInquiryReg,
      BasicCustomerInquiryReg},
    data() {
      return {}
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>

</style>
